import { GridFilterOperator, getGridSingleSelectOperators, getGridStringOperators } from '@mui/x-data-grid';

const allStringOperators = getGridStringOperators();
const equalsOperator = allStringOperators.find((operator) => operator.value === 'equals');
const stringOperator = equalsOperator ? [equalsOperator] : allStringOperators;

const allSingleSelectOperators = getGridSingleSelectOperators();
const isOperator = allSingleSelectOperators.find((operator) => operator.value === 'is');
const singleSelectOperator = isOperator ? [isOperator] : allSingleSelectOperators;

export const getColumnFilterOperators = (
  type: string | undefined,
  filterOperators: readonly GridFilterOperator[] | undefined
) => {
  if (type === 'singleSelect') {
    return {
      filterOperators: singleSelectOperator,
    };
  }

  if (type === 'string') {
    return {
      filterOperators: stringOperator,
    };
  }

  return {
    filterOperators,
  };
};
